module.exports = __webpack_public_path__ + "img/main_hy.4c238820.jpg";